<template>
    <div
        :class="[
            'product_item_price', product.discount_active ? 'discount_active' : '',
            product.sell_status ? 'sell_status-' + product.sell_status : '',
            product.price_type ? 'price_type-' + product.price_type : ''
            ]"
        @click.prevent="activeEdit()" :data-indicador="indicador"
    >
        <div :class="['price_product', (product.price_type=='contact' || product.sell_status=='showcase') ? 'edit_price_contact' : '']">
            <div v-if="product.price_type!='contact' && product.sell_status!='showcase'" class="price_type_display">
                <span v-if="product.price_type=='variable'" >{{ lang.bsop_from }}: </span>
                <div v-if="product.discount_active && product.discount_percent > 0" class="product_item_price_discount">
                    {{currency}} {{ precio_final | formatMoney}}
                </div>
                <div v-else class="normal">
                    {{currency}} {{ precio_final | formatMoney}}
                </div>
                <div v-if="product.discount_active && product.discount_percent > 0" :class="[product.discount_active ? 'with_discount' : '']">
                    <span class="line-through">{{currency}} {{ product.price | formatMoney}}</span>
                    <span class="offer_special" v-if="product.discount_percent > 0"> You save {{ product.discount_percent }}%</span>
                </div>
            </div>
            <div v-else class="price_type_display">
                <i class="fa fa-pen"></i> Price
            </div>
        </div>
        <div class="input_quantity" v-if="product.allow_quantity && product.price_type!='contact' && product.sell_status=='available'">
            <div class="form-group">
                <div class="input-group">
                    <span class="input-group-text" style="padding:0;">
                        <button class="btn_quantity" @click="calcQuantity('-')">-</button>
                    </span>
                    <input type="text" class="form-control quantity" value="1" readonly min="1" v-model="qty">
                    <span class="input-group-text" style="padding:0;">
                        <button class="btn_quantity" @click="calcQuantity('+')">+</button>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import AmountInput from "@/apps/billing/components/calcManual/inputs/AmountInput.vue";
import PercentInput from "@/apps/billing/components/estpro/secForm/PercentInputInt.vue";
import { mapGetters } from "vuex";
export default {
    components: {
        AmountInput,
        PercentInput,
    },
    props: ['indicador', 'product'],
    data(){
        return {
            lang: {
                bsop_from: '',
                bsop_incorrect_amount: '',
                bs_error: '',
                bs_could_not_save: '',
            },
            loadSave: false,
            editActive: false,
            apis: null,
            currency: null,
            price_old: null,
            qty: 1,
            contact_btn_text: 'Contact',
            show_btn_ws: false,
        };
    },
    computed: {
        ...mapGetters("ModApps/Marketea/", {
            get_currency: "get_bStore_currency",
            get_info: "get_bStore_info",
            langGetter: "lang",
        }),
        precio_final: function() {
            if(this.product.discount_active && this.product.discount_percent > 0){
                return (this.product.price - ((this.product.discount_percent * this.product.price) / 100));
            }
            return this.product.price;
        }
    },
    watch: {
        langGetter() { this.lang = this.$store.getters['ModApps/Marketea/lang']; },
        get_currency(){
            this.currency = this.get_currency;
            console.log('watch currency', this.currency)
        },
        get_info: {
            handler(newVal){
                let t = this;
                // console.log('get_info', newVal);
                t.contact_btn_text = (newVal && newVal.contact_btn_text) ? newVal.contact_btn_text : 'Contact';
                t.show_btn_ws = !!(newVal && Number(newVal.show_btn_ws) > 0);
            },
            deep: true,
            immediate: true,
        },
    },
    created(){
        let t = this;
        this.lang = this.$store.getters['ModApps/Marketea/lang'];
        let urlApis = this.$store.getters['ModApps/Marketea/urlApis'];
        this.apis = urlApis.bStore;
        this.currency = this.$store.getters['ModApps/Marketea/get_bStore_currency'];
        console.log('created currency', this.currency)
        // `get_info` watcher is immediate and deep; it initializes `contact_btn_text` and `show_btn_ws`
        this.price_old = this.product.price
        // console.log('created currency', this.currency)
    },
    methods: {
        activeEdit(){
            this.$emit('openEditPrice', true); // Emitir evento para abrir el editor de precio
        },
        inactiveEdit(){
            // console.log('inactiveEdit');
            this.editActive = false;
        },
        noEnter(e){
            let t = this;
            var code = (e.which) ? e.which : e.keyCode;
            if(code == 13){
                e.preventDefault();
                t.inactiveEdit();
                t.saveProductPrice()
            }
        },
        saveProductPrice(){
            let t= this;
            let urlService = t.apis.set(3)// setProduct
            if(t.isEmptyNaN(t.product.price)){
                t.$notify({
                    group: "noti",
                    type: "error",
                    title: t.lang.bs_error,
                    text: t.lang.bsop_incorrect_amount,
                });
                t.product.price = t.price_old;
            }else{
                if(!t.loadSave){
                    t.loadSave = true;
                    // @ts-ignore
                    window.master.post(urlService, t.product)
                    .then((response) => {
                        console.log(urlService, t.product, response.data);
                        t.loadSave = false;
                    })
                    .catch((error) => {
                        console.log(error);
                        t.loadSave = false;
                        t.$notify({
                            group: "noti",
                            type: "error",
                            title: t.lang.bs_error,
                            text: t.lang.bs_could_not_save,
                        });
                    });
                }
            }
        },
        onModeCalcChange(e){
            this.product.discount_active = Number(e.target.checked); // convert boolean to 0 or 1
            this.saveProductPrice();
        },
        onChangeAllowAuantity(e){
            this.product.allow_quantity = Number(e.target.checked); // convert boolean to 0 or 1
            this.saveProductPrice();
        },
        convertToNumeric(val){
            let num;
            if (typeof val === "boolean") {
            // Caso: ya es boolean
            num = Number(val);
            } else if (typeof val === "string") {
            // Caso: es string, validamos contenido
            num = (val.toLowerCase() === "true") ? 1 : 0;
            } else {
            // Otro tipo, opcional
            num = 0;
            }
            return num;
        },
        isEmptyNaN(val){
            if (isNaN(val)){ return true;}
            else if (val==null){ return true;}
            else if (val==''){ return true;}
            else{ return false;}
        },
        calcQuantity(oper){
            if(oper=='+'){ this.qty++;}
            if(oper=='-'){
                this.qty = (this.qty>1) ? this.qty - 1 : 1;
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.product_item_price{
    cursor: pointer;
}
</style>
